import { oneOf } from 'prop-types'

export const dropdownPlacementTypes = Object.freeze({
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right'
})

export const dropdownPlacementTypesPropType = oneOf([
    dropdownPlacementTypes.TOP_RIGHT,
    dropdownPlacementTypes.TOP_LEFT,
    dropdownPlacementTypes.BOTTOM_RIGHT,
    dropdownPlacementTypes.BOTTOM_LEFT
])
